import { z } from "zod";

import {
  CampaignDtoSchema,
  CampaignWithIdSchema,
} from "../../../dtos/deprecated/campaigns";

export const PostCampaignRequestBodySchema = CampaignDtoSchema;

export type PostCampaignRequestBodyType = z.infer<
  typeof PostCampaignRequestBodySchema
>;

export const PostCampaignResponseBodySchema = z.object({
  campaign: CampaignWithIdSchema,
});

export type PostCampaignResponseBodyType = z.infer<
  typeof PostCampaignResponseBodySchema
>;
